export const useAuth = () => {
  const userInStorage = localStorage.getItem("user");
  const userObject =
    userInStorage && userInStorage !== "undefined" ? userInStorage : "{}";
  const userObjectParsed = JSON.parse(userObject);

  // Check if user has the required structure for v2.0.0+
  // v2.0.0 added a 'companies' array and ensures company.id exists
  const hasValidStructure = Boolean(
    userObjectParsed?.companies &&
      Array.isArray(userObjectParsed.companies) &&
      userObjectParsed?.company?.id &&
      userObjectParsed?.company?.id !== 0
  );
  const isUserAuth =
    userInStorage !== null &&
    userInStorage !== "undefined" &&
    Object.keys(userObjectParsed).length > 0 &&
    hasValidStructure;

  return {
    isUserAuth,
    user: userObjectParsed,
  };
};
